import {
    convertCurrencyFormatPositiveNegative,
    RaikoBaseCardContainer, RaikoCustomSimpleActiveDeActiveChip, RaikoCustomTable,
    RaikoGridOneColumn, RaikoMultiSelectTable,
    RaikoTableTitleContainer,
    showErrorMessage, showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {useParams} from "react-router-dom";
import {FundService} from "../../../serverService/fund/FundService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {useEffect, useState} from "react";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";

export default function FundAdminDetailFunds({selectedFunds, setSelectedFunds}) {

    const {id: adminId = -1} = useParams()

    let page = 0;
    const size = 20;

    const service = new FundService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [tableLoading, setTableLoading] = useState(false)
    const [pageCount, setPageCount] = useState("");
    const [totalItems, setTotalItems] = useState("");
    const [funds, setFunds] = useState([])
    const [selectedFundsTable, setSelectedFundsTable] = useState(selectedFunds)

    useEffect(() => {
        getFundsFromServer()
    }, []);


    function getFundsFromServer() {
        setTableLoading(true)

        service.getFundsList(page, size)
            .then(response => {
                setFunds([])
                setTotalItems(response.numberOfItems)
                setPageCount(response.totalPage)

                response.data.map((item, index) => {
                    setFunds(prev => [
                            ...prev,
                            {
                                number: ((page) * size) + index + 1,
                                id: item.id,
                                // item.cashBalance,
                                // item.countOfGroup,
                                // item.countOfMember,
                                enabled: <RaikoCustomSimpleActiveDeActiveChip
                                    state={item.enabled}
                                    activeStateTitle={"فعال"}
                                    deActiveStateTitle={"غیرفعال"}
                                />,
                                name: item.name,
                                // item.postalAddress,
                                balance: convertCurrencyFormatPositiveNegative(item.totalBalance),
                                // item.totalLoanAmount
                            }
                        ]
                    )
                })
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })
    }

    function handleChangePagination(newPage) {
        page = newPage
        getFundsFromServer()
    }

    function handleUpdate() {
        if (selectedFundsTable.length > 0) {
            loading.show()
            service.updateFundAdminSelectedFund(
                adminId,
                selectedFundsTable[0].id
            ).then(response => {
                showSuccessMessage("بروزرسانی صندوق با موفقیت انجام شد.")
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        } else
            showWarningMessage("لطفا ابتدا صندوق مورد نظر را انتخاب نمایید.")
    }

    return (
        <RaikoGridOneColumn>
            <RaikoBaseCardContainer>
                <RaikoGridOneColumn>
                    <RaikoTableTitleContainer
                        title={"صندوق ها"}
                        amount={totalItems}
                        hasCreateNewItem
                        handleCreateNewItem={handleUpdate}
                        createNewItemTitle={"بروزرسانی"}
                    />
                    <RaikoMultiSelectTable
                        tableHeader={header}
                        tableData={funds}
                        tableLoadingState={tableLoading}
                        pageCount={pageCount}
                        selectedItems={selectedFundsTable}
                        setSelectedItems={setSelectedFundsTable}
                        handleChangePagination={handleChangePagination}
                        selectedItemsTitle={"صندوق انتخاب شده"}
                        tableHintTitle={"صندوق مورد نظر را انتخاب نمایید."}
                        isSingleSelect={true}
                    />
                </RaikoGridOneColumn>
            </RaikoBaseCardContainer>
        </RaikoGridOneColumn>
    )
}

const header = [
    {
        id: "number",
        label: "#"
    },
    {
        id: "name",
        label: "نام"
    },
    {
        id: "balance",
        label: "موجودی"
    },
    {
        id: "enabled",
        label: "وضعیت"
    },
]
